module.exports = __webpack_public_path__ + "static/media/Dana Kawas.c7055460.png";